import React from "react";
import CustomInput from "../../../../common/CustomInput";
import Button from "../../../../common/Button";

const AllergyInformationHeader = ({
  setIsActiveAllergyPresent,
  setConfirmNoAllergy,
  allAllergies,
  setShowCreateSlider,
  isActiveAllergyPresent,
  filterOptions,
  tableFilter,
  setTableFilter,
  allergies
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex">
        <div className="flex justify-center items-center pr-6">
          <h3>
            <input
              id="known-allergy"
              name="known-allergy"
              onChange={() => {
                setIsActiveAllergyPresent(true);
                setConfirmNoAllergy(false);
                if (allAllergies.length === 0) {
                  setShowCreateSlider(true);
                }
              }}
              value={isActiveAllergyPresent === true}
              checked={isActiveAllergyPresent === true}
              type="radio"
              className="w-[45px] h-[45px] border-gray-100 cursor-pointer form-radio text-REELTeal focus:ring-transparent"
            />
          </h3>
        </div>
        <div className="flex flex-col">
          <h3 className="text-xl font-semibold text-gray-900">
            {allergies.length > 0 ? "Allergy Information" : "Add Allergy"}
          </h3>
          <p className="text-body-md text-gray-800">
            Drug, Food, Environmental, Other <span className="text-teal-300">(Delete all allergies to enable 'No Known Allergies'.)</span>
          </p>
        </div>
      </div>
      {isActiveAllergyPresent === true && (
        <div className="flex justify-between">
          <CustomInput
            options={filterOptions}
            name="All"
            className="font-semibold mr-6 bg-white !py-[14px] rounded-[4px] !px-[16px] text-body-md !w-[200px] !h-full"
            type="dropdown"
            showOptionalLabel={false}
            value={tableFilter}
            onChange={(e) => setTableFilter(e.value)}
          />
          <Button
            className="flex mr-4 !py-[14px] rounded-[4px] !px-[32px] text-body-md !w-[200px] !h-full"
            type="primary"
            text="Add Allergy"
            onClick={() => {
              setShowCreateSlider(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AllergyInformationHeader;
